// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import Login from '../Login/Login';
import SubmitButton from '../../Util/SubmitButton/SubmitButton';
import Request from '../../../api/Request';

@inject('modalStore', 'messageStore')
@observer class Register extends Component<any, any> {

	@observable username = '';
	@observable password = '';
	@observable passwordConfirm = '';
	@observable loading = false;

	maxLengthUsername: number = 30;

	constructor(props: any) {
		super(props);

		this.login = this.login.bind(this);
		this.register = this.register.bind(this);
		this.onChangeUsername = this.onChangeUsername.bind(this);
	}

	login(e: any): void {
		e.preventDefault();
		
		this.props.modalStore.createModal('Login', (<Login />));
	}

	register(e: any): void {
		e.preventDefault();
		if(!this.loading) {
			if(this.username === '') {
				this.props.messageStore.setMessage('error', 'the username field has to be set');
				return;
			}
			if(this.password === '') {
				this.props.messageStore.setMessage('error', 'the password field has to be set');
				return;
			}
			if(this.passwordConfirm === '') {
				this.props.messageStore.setMessage('error', 'the passwordConfirm field has to be set');
				return;
			}
			if(this.passwordConfirm !== this.password) {
				this.props.messageStore.setMessage('error', 'the passwordConfirm and password have to be the same');
				return;
			}
			this.loading = true;
			Request.post('/auth/register', {
				username: this.username,
				password: this.password,
				passwordConfirm: this.passwordConfirm
			}, {}, false).then((response) => {
				if(response.status && response.status !== 200) {
					if(response.message === 'given value is a duplicate') {
						this.props.messageStore.setMessage('error', 'your given username already exists');
					} else {
						this.props.messageStore.setMessage('error', response.message);
					}
				} else {
					this.props.messageStore.setMessage('success', 'successfully created user.', 2000)
					this.props.modalStore.createModal('Login', (<Login username={response.username} />))
				}
				this.loading = false;
			}).catch((e) => {
				this.loading = false;
			});
		}
	}
	onChangeUsername(e: any) {
		if (e.target.value.length < this.maxLengthUsername) {
			this.username = e.target.value;			
		}
	}

	render() {
		return (
			<form onSubmit={this.register} className="user-form">
				<label>
					username:
					<input type="text" name="username" value={this.username} onChange={this.onChangeUsername}/>
				</label>
				<label>
					password:
					<input type="password" name="password" value={this.password} onChange={(e) => this.password = e.target.value}/>
				</label>
				<label>
					confirm password:
					<input type="password" name="passwordConfirm" value={this.passwordConfirm} onChange={(e) => this.passwordConfirm = e.target.value}/>
				</label>
				<SubmitButton text="Register" loading={this.loading} />
				<p><a href="#" onClick={this.login}>Log in.</a></p>
			</form>
		)
	}
}

export default Register;